export default {
  priority: 95,
  name: app.translate("routes.home.attendance.leave.cartex"),
  path: "Cardex",
  permissions: [
    "TimeAttendanceMenu/RemainingLeaveMenu/Kardex",
  ],
  component: load(() =>
    import(/* webpackChunkName: "amount" */ "./LeaveReport")
  ),
  icon: "folder-plus",
  drawer: true,
};
